// extracted by mini-css-extract-plugin
module.exports = {"navbar":"NavBar_navbar__yNL3i","title":"NavBar_title__3XrU0","titleSpan":"NavBar_titleSpan__1XIq9","linkStyle":"NavBar_linkStyle__23BIE"};